// Credit purchase packages — keep server-side ALLOWED_PACKAGES in sync
// (sohozkaj-backend/src/routes/payments.js).
// Baseline: 1tk = 1cr. discount = Math.round((1 - amount/credits) * 100).

export const CREDIT_PACKAGES = [
    { amount: 10,  discount: 50, credits: 20   },
    { amount: 50,  discount: 50, credits: 100  },
    { amount: 100, discount: 60, credits: 250  },
    { amount: 300, discount: 63, credits: 800  },
    { amount: 500, discount: 67, credits: 1500 },
];

// Per-action costs — keep in sync with backend src/services/CreditService.js
// (DB Settings can override these on the backend, but this client-side breakdown
// uses the defaults for display purposes only).
export const CREDIT_COSTS = {
    IMAGE: 5,
    IMAGE_MANUAL: 3,
    DOCUMENT: 4,
    AI_DOCUMENT: 8,
    AI_TEMPLATE: 5,
    PRINT: 3,
    BULK_PHOTO: 4,
    QUESTION_CREATE: 1,
    QUESTION_EXPORT: 1,
    FORM_FILL: 0,
    EXTENSION_FILL: 0,
    AI_TOOL: 1,
};

// New wallet-system per-action costs (1 credit = 1 tk) — keep in sync with backend
// DEFAULT_WALLET_COSTS in CreditService.js. Used as a display fallback for the
// legacy → wallet cost arrow before /api/credits/costs resolves.
export const WALLET_CREDIT_COSTS = {
    IMAGE: 2,
    IMAGE_MANUAL: 1,
    DOCUMENT: 2,
    AI_DOCUMENT: 4,
    AI_TEMPLATE: 3,
    PRINT: 2,
    BULK_PHOTO: 1,
    QUESTION_CREATE: 1,
    QUESTION_EXPORT: 1,
    FORM_FILL: 1,
    EXTENSION_FILL: 1,
    AI_TOOL: 1,
};

export const calculateActionsBreakdown = (credits, costs = CREDIT_COSTS) => ({
    images: Math.floor(credits / costs.IMAGE),
    documents: Math.floor(credits / costs.DOCUMENT),
    manualEdits: Math.floor(credits / costs.IMAGE_MANUAL),
    aiTemplates: Math.floor(credits / costs.AI_TEMPLATE),
    prints: Math.floor(credits / (costs.PRINT || 3)),
    // How many photos the user can process through Bulk Edit (per-photo cost).
    bulkPhotos: Math.floor(credits / (costs.BULK_PHOTO || 1)),
});
